import { VelocityEnv } from '@velocity-exchange/sdk';
import { EnvironmentConstants } from '@velocity-exchange/common';

export const getRpcOptions = (driftEnv: VelocityEnv) => {
	return driftEnv === 'devnet'
		? EnvironmentConstants.rpcs.dev
		: EnvironmentConstants.rpcs.mainnet;
};
